import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import type SvgIcon from '@mui/material/SvgIcon';
import { JobKind } from './jobModel';

export const JOB_KIND_META: Record<JobKind, { label: string; Icon: typeof SvgIcon }> = {
  export: { label: 'Exports', Icon: CloudUploadOutlined },
  label: { label: 'Labels', Icon: LocalShippingOutlined },
  mapping: { label: 'Mapping', Icon: DescriptionOutlined },
};
